import * as React from 'react';
import { Config, useFetchBannerInfo } from './banner/helpers';
import { Wrapper, ImageBanner, VideoBanner } from './banner/components';

export default function (props) {
  const {
    banner_id: bannerID = null,
  } = props;

  const {
    currentState,
    title,
    html,
    cta,
    url,
    target,
    format,
    image,
    links,
    poster,
    video,
  } = useFetchBannerInfo(bannerID);

  if (currentState === Config.State.broken || currentState === Config.State.initial) {
    return null;
  }

  switch (format) {
    case Config.Banner.Format.image:
      return (
        <Wrapper format={format}>
          <ImageBanner
            cta={cta}
            html={html}
            image={image}
            links={links}
            target={target}
            title={title}
            url={url}
          />
        </Wrapper>
      );
    case Config.Banner.Format.video:
      return (
        <Wrapper format={format}>
          <VideoBanner
            cta={cta}
            html={html}
            links={links}
            poster={poster}
            target={target}
            title={title}
            url={url}
            video={video}
          />
        </Wrapper>
      );
    default:
      return null;
  }
}
